import * as React from "react";

export const NotAvailable = () => {
  return <span style={{ fontStyle: "italic" }}>Unknown</span>;
};
